import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { BackboneComponent } from '@components/backbone/backbone.component';
import { BreadcrumbComponent } from '@components/breadcrumb/breadcrumb.component';
import { AppService } from '@services/app.service';
import { marked } from 'marked';
import { TabViewModule } from 'primeng/tabview';

@Component({
  selector: 'app-changelog',
  imports: [CommonModule, BackboneComponent, BreadcrumbComponent, TabViewModule],
  templateUrl: './changelog.component.html',
  styleUrl: './changelog.component.scss',
})
export class ChangelogPage {
  private http = inject(HttpClient);
  private appService = inject(AppService);
  private sanitizer = inject(DomSanitizer);

  public changelogAragorn!: SafeHtml;
  public changelogSauron!: SafeHtml;

  ngOnInit(): void {
    marked.setOptions({
      gfm: true,
      breaks: false,
    });

    this.appService.changelogAragorn().then((response: string) => {
      let html = marked.parse(response) as string;

      // Elimina etiquetas <a> pero conserva el texto
      html = html.replace(/<a[^>]*>(.*?)<\/a>/gi, '$1');

      this.changelogAragorn = this.sanitizer.bypassSecurityTrustHtml(html);
    });

    this.appService.changelogSauron().then((response: any) => {
      let html = marked.parse(response.data) as string;

      // Elimina etiquetas <a> pero conserva el texto
      html = html.replace(/<a[^>]*>(.*?)<\/a>/gi, '$1');

      this.changelogSauron = this.sanitizer.bypassSecurityTrustHtml(html);
    });
  }
}
